import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@data/store';

const root = (root: RootState) => root;

export const userRootSelector = createSelector(root, root => root.auth);
export const userSelector = createSelector(userRootSelector, root => root.user);
export const accessTokenRootSelector = createSelector(
  userRootSelector,
  root => root.accessToken
);

export const refreshTokenRootSelector = createSelector(
  userRootSelector,
  root => root.refreshToken
);

export const isAuthenticatedSelector = createSelector(
  accessTokenRootSelector,
  accessToken => {
    return Boolean(accessToken);
  }
);

export const authErrorSelector = createSelector(
  userRootSelector,
  root => root.errors
);

export const isAuthLoadingSelector = createSelector(
  userRootSelector,
  root => root.isLoading
);

export const accessTokenSelector = createSelector(
  accessTokenRootSelector,
  root => root?.token
);

export const refreshTokenSelector = createSelector(
  refreshTokenRootSelector,
  root => root?.token
);
